import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { CardCustom } from '@ingenico/react-ui/card-custom';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import type { ReactNode } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { LogicalDeviceFirmwareCardProps } from './logicalDeviceFirmwareCard.model';
import styles from './logicalDeviceFirmwareCard.module.scss';

function LogicalDeviceFirmwareCardCpt({ firmware }: LogicalDeviceFirmwareCardProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE, ALL_LNGS_NAMESPACES.PHYSICAL_DEVICE]);
  return (
    <CardCustom className={styles.container}>
      <CoreTypography variant={CoreTypographyVariant.Title02Bold}>{t('deviceProperties.osVersion')}</CoreTypography>
      <div className={styles.textContainer}>
        <CoreTypography customClassName={styles.label} variant={CoreTypographyVariant.Body03Regular}>
          {t('devicePropertiesSections.installedFirmware')}
        </CoreTypography>
        <CoreTypography variant={CoreTypographyVariant.Body03Regular}>{firmware}</CoreTypography>
      </div>
    </CardCustom>
  );
}

export const LogicalDeviceFirmwareCard = memo(LogicalDeviceFirmwareCardCpt);
